import { render, staticRenderFns } from "./ViolationEliminatedButton.vue?vue&type=template&id=697fed6e&"
import script from "./ViolationEliminatedButton.vue?vue&type=script&lang=ts&"
export * from "./ViolationEliminatedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports